module.exports = __webpack_public_path__ + "img/ve.n.to__1.75f3ac67.jpg";